var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-signin-button',{staticClass:"btn",attrs:{"params":_vm.googleSignInParams},on:{"success":_vm.onSignInSuccess,"error":_vm.onSignInError}},[_vm._v("Ingresar")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6565320","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login-gmail.vue
// module id = 1204
// module chunks = 0